import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LoaderCircle, SearchIcon } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { stickerStore } from "store/stickerStore";

interface StickerPickerProps {
  onStickerSelect: (sticker: string) => void;

  stickerPickerRef: React.RefObject<HTMLDivElement>;
}

const StickerPicker: React.FC<StickerPickerProps> = ({
  onStickerSelect,
  stickerPickerRef,
}) => {
  const stickerContainerRef = useRef<HTMLDivElement>(null);
  let searchTextCurrent = useRef<string>("");
  const [packName, setPackName] = useState<string>("");
  const { stickers, appRecord, initializePage, fetchStickers, stickerPacks } =
    stickerStore();
  useEffect(() => {
    const loadInitialStickers = async () => {
      initializePage();
    };

    loadInitialStickers();
  }, [initializePage]);
  useEffect(() => {
    const handleScroll = () => {
      const container = stickerContainerRef.current;
      if (
        container &&
        container.scrollHeight - container.scrollTop <=
          container.clientHeight + 10 &&
        appRecord.canLoadMore()
      ) {
        console.log("loading more");
        fetchStickers({
          packName: packName,
          searchText: searchTextCurrent.current,
        });
      }
    };

    const container = stickerContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [appRecord, fetchStickers, packName]);

  return (
    <div
      ref={stickerPickerRef}
      className=" left-0 border dark:bg-[#3A3B3C] dark:border-gray-600 border-gray-200 bg-white shadow-lg pl-4 pr-4 pt-2 pb-4 rounded-lg z-50 w-80"
    >
      {/* absolute bottom-[0px]  */}
      <div className="flex gap-2 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 p-2 mb-2">
        {stickerPacks.map((pack) => (
          <div
            key={pack.id}
            className="flex flex-shrink-0 w-6 h-w-6 cursor-pointer relative"
            onClick={() => {
              setPackName(pack.name);
              searchTextCurrent.current = "";
              fetchStickers({
                isRefresh: true,
                searchText: searchTextCurrent.current,
                packName: pack.name,
              });
            }}
          >
            {pack.id === "0" ? (
              <SearchIcon />
            ) : (
              <img src={pack.thumbnail_url} alt={pack.name} />
            )}
            {packName === pack.name && (
              <div className="w-6 h-1 bg-blue-500 rounded-full absolute bottom-[-6px]"></div>
            )}
          </div>
        ))}
      </div>

      {packName === "" ? (
        <div className="flex items-center space-x-2 mb-4 font-semibold text-gray-700 w-full">
          <div className="relative w-full">
            <input
              type="text"
              className="border border-gray-300 rounded-lg p-1 pl-10 w-full"
              placeholder="Search Stickers"
              onChange={(e) => {
                searchTextCurrent.current = e.target.value;
                fetchStickers({
                  isRefresh: true,

                  packName: packName,
                  searchText: e.target.value,
                });
              }}
            />
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
              onClick={(e) => {
                e.stopPropagation();
                console.log("Search icon clicked");
              }}
            />
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className="h-72 overflow-y-auto" ref={stickerContainerRef}>
        {appRecord.isLoading() ? (
          <div className="w-full flex justify-center">
            <LoaderCircle size={30} className="animate-spin text-yellow-400" />
          </div>
        ) : (
          <>
            {" "}
            {Object.entries(stickers).map(([packName, stickerList]) => (
              <div key={packName}>
                <h4 className="text-sm font-semibold mb-2">{packName}</h4>
                <div className="grid grid-cols-4 gap-4 space-y-2">
                  {stickerList.map((sticker) => (
                    <div
                      key={sticker.id}
                      className="sticker-item cursor-pointer"
                    >
                      <img
                        src={sticker.thumbnail_url}
                        alt={sticker.pack_name}
                        className="sticker-image"
                        onClick={() => onStickerSelect(sticker)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default StickerPicker;
